import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-20" data-id="element-52" data-mp="1gdgzbbjl6g1o">
      <div className="mx-auto max-w-[720px] px-5 sm:px-6" data-id="element-53" data-mp="1gausxf8fm6l1">
        <Reveal className="text-center" data-id="element-54" data-mp="2dz4xa0vox6fb">
          <h2 className="text-[26px] font-bold tracking-tight text-forest sm:text-[30px]" data-id="element-55" data-mp="2dy3gdfrztppo">
            Tus Dudas, Resueltas
          </h2>
          <p className="mt-2 text-[15px] text-warmgray" data-id="element-56" data-mp="241gwoubel4p8">
            Si algo te impide tomar acción, aquí está la respuesta.
          </p>
        </Reveal>

        <ul className="mt-8 space-y-3" data-id="element-57" data-mp="1z5jh4q7ys2di">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <Reveal as="li" key={faq.question} delay={i * 0.05} data-id="element-58" data-mp="nnighxvzjf5g" data-mpi={i}>
                <div className="overflow-hidden rounded-xl bg-white shadow-sm" data-id="element-59" data-mp="nq4kjnjo3cix">
                  <h3 data-id="element-60" data-mp="piplzzsqef5e">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-gold" data-id="element-61" data-mp="pg3hya51uhrx">
                      <span className="text-[15px] font-bold leading-snug text-charcoal" data-id="element-62" data-mp="6qwwifcvfc2f">
                        {faq.question}
                      </span>
                      <motion.span animate={{
                    rotate: isOpen ? 180 : 0
                  }} transition={{
                    duration: 0.25,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="shrink-0" data-id="element-63" data-mp="bk9dq4f80gl5">
                        <ChevronDownIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-64" data-mp="3jz19fn2qhr7a" />
                      </motion.span>
                    </button>
                  </h3>

                  <AnimatePresence initial={false} data-id="element-65" data-mp="1ugky8d724cmz">
                    {isOpen && <motion.div id={`faq-panel-${i}`} key="panel" initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-66" data-mp="1uixnzcj23ral">
                        <p className="px-5 pb-5 text-[15px] leading-relaxed text-warmgray" data-id="element-67" data-mp="28hx7y6vmji0f">
                          {faq.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.08} className="mt-12 flex flex-col items-center text-center" data-id="element-68" data-mp="s35hhzi1gktr">
          <ShieldCheckIcon className="h-16 w-16 text-gold" strokeWidth={1.3} aria-hidden="true" data-id="element-69" data-mp="nzpmf7lmasj6" />
          <h3 className="mt-3 text-xl font-bold tracking-tight text-forest" data-id="element-70" data-mp="2zox9d2fw4obs">
            Garantía Blindada de 07 Días
          </h3>
          <p className="mt-2 max-w-[500px] text-[15px] leading-relaxed text-charcoal" data-id="element-71" data-mp="33pz9dlhmt4et">
            Si no sientes que tu energía volvió, la hinchazón desapareció y los antojos se redujeron
            — te devolvemos el 100%. Sin preguntas. Un solo email es todo lo que necesitas.
          </p>
        </Reveal>
      </div>
    </section>;
}